import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { MENU_KIDS, RecordItem } from '@app/models/record.model';
import { ApiService } from '@app/services/api.service';

export interface UserNote {
  username: string;
  notes: RecordItem[];
}

@Component({
  selector: 'app-daily-record',
  templateUrl: './daily-record.component.html',
  styleUrls: ['./daily-record.component.scss'],
})
export class DailyRecordComponent implements OnChanges {
  // @Input() date: Date = new Date();
  // @Input() current?: boolean;
  // @Input() userNotes?: UserNote[];
  @Input() data: any;
  @Input() sdate: string = '';
  @Input() edate: string = '';
  @Input() name: any;
  @Input() userHeader: boolean = true;
  screen: string | MENU_KIDS = MENU_KIDS.AREDASITE;
  stfnm?: string = "";
  screenKIDS = MENU_KIDS;
  titles: any[] = [];
  bdView: boolean = false;

  isExpanded: boolean = true;
  screenItem: string | null = null;
  private officeObjkbn: number[] = [21, 22, 23, 24];
  get isOfficeRecord() {
    return this.data?.notes?.some((x: any) => this.officeObjkbn.some(n => x.data.some((note: any) => note.objkbn == n.toString()))) || false;
  }

  constructor(
    private apiService: ApiService,
  ) {
    let officeSettingStr = localStorage.getItem('officeSetting');
    if (officeSettingStr) {
      const officeSetting = JSON.parse(officeSettingStr);
      this.bdView = parseInt(officeSetting?.office_st?.officeSettings?.bdview) == 1;
    }

  }

  async ngOnChanges(changes: SimpleChanges): Promise<void> {
    this.screen = localStorage.getItem('menu') || MENU_KIDS.AREDASITE;
    this.screenItem = localStorage.getItem('menuItem') ?? null;
    this.getProfile();
    if (!changes['data']) return;
    // if (this.screen === this.screenKIDS.KORU) {
    //   const notes = this.data.notes;
    //   await this.preloadData(notes || []);
    // } else {
    //   const notes = this.data.notes.flatMap((x: any) => x.data);
    //   await this.preloadData(notes || []);
    // }
    const notes = this.data.notes.flatMap((x: any) => x.data);
    await this.preloadData(notes || []);
  }

  changeExpand() {
    this.isExpanded = !this.isExpanded
  }

  getProfile() {
    try {
      const _profileStr = localStorage.getItem('profile');
      if (_profileStr === '' || !_profileStr) return;
      const objProfile = JSON.parse(_profileStr);
      this.stfnm = objProfile["fullName"] || '';
    } catch (error) {
      console.log(error);
    }

  }

  async preloadData(notes: RecordItem[]) {
    if (notes.length === 0) return;
    for (let note of notes) {
      let title = await this.apiService.fetchTitleData(note);
      if (title) {
        const findIndex = this.titles.findIndex(x => x?.ttlkbn === title.ttlkbn
          && x?.ttlcd === title?.ttlcd);
        if (findIndex < 0) {
          this.titles = [...this.titles, title];
        }
      }
    }
  }
}
